var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 29H99M99 29L89.5405 19M99 29L89.5405 39",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99 99H29M29 99L38.4595 89M29 99L38.4595 109",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 23,
    fill: "#EF2C5A",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.706 56.9708C74.2918 56.385 74.2918 55.4353 73.706 54.8495C73.1202 54.2637 72.1705 54.2637 71.5847 54.8495L64.2757 62.1585L56.9669 54.8497C56.3811 54.2639 55.4314 54.2639 54.8456 54.8497C54.2598 55.4355 54.2598 56.3853 54.8456 56.971L62.1544 64.2798L54.8456 71.5886C54.2598 72.1744 54.2598 73.1241 54.8456 73.7099C55.4314 74.2957 56.3811 74.2957 56.9669 73.7099L64.2757 66.4011L71.5847 73.7101C72.1705 74.2959 73.1202 74.2959 73.706 73.7101C74.2918 73.1243 74.2918 72.1746 73.706 71.5888L66.397 64.2798L73.706 56.9708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransactions);
export default __webpack_public_path__ + "static/media/no-transactions.f9ea55c8cacd12fe798798e3ae6bda83.svg";
export { ForwardRef as ReactComponent };